<template>
    <div class="row text-center">
      <div class="col-3">
        <div class="p-3" :class="`rounded ${classes}`" :style="this.styles">
          <div>
            <span class="h2">{{difference.days}}</span>
          </div>
          <div>
            <small class="text-capitalize">{{'days' | translate}}</small>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="p-3" :class="`rounded ${classes}`" :style="this.styles">
          <div>
            <span class="h2">{{difference.hours}}</span>
          </div>
          <div>
            <small class="text-capitalize">{{'hours' | translate}}</small>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="p-3" :class="`rounded ${classes}`" :style="this.styles">
          <div>
            <span class="h2">{{difference.minutes}}</span>
          </div>
          <div>
            <small class="text-capitalize">{{'minutes' | translate}}</small>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="p-3" :class="`rounded ${classes}`" :style="this.styles">
          <div>
            <span class="h2">{{difference.seconds}}</span>
          </div>
          <div>
            <small class="text-capitalize">{{'seconds' | translate}}</small>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import _ from 'lodash'
import dayjs from 'dayjs'

export default {
  props: [
    'date',
    'customClasses',
    'bgColorHex',
    'textColorHex',
  ],
  data () {
    return {
      interval: null,
      difference: {
        total: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      }
    }
  },
  mounted () {
    this.difference = this.timerCount(this.endDate)

    this.interval = setInterval(() => {
      this.difference = this.timerCount(this.endDate)
      if (this.difference.total === -1) {
        clearInterval(this.interval)
      }
    }, 1000)
  },
  methods: {
    addZero(number) {
      if (number < 10) {
        return `0${number}`
      }
      return number
    },
    timerCount (endDate) {
      // endDate = dayjs(endDate)
      let now = dayjs()
      let diff = endDate.diff(now)

      if (diff < 0) {
        return {
        total: diff,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
        }
      }

      let total = diff
      let days = Math.floor(diff / (1000 * 60 * 60 * 24))
      let hours = this.addZero(Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)))
      let minutes = this.addZero(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)))
      let seconds = this.addZero(Math.floor((diff % (1000 * 60)) / 1000))

      return {
        total,
        days,
        hours,
        minutes,
        seconds,
      }
    }
  },
  computed: {
    endDate() {
      return dayjs(this.date) || null
    },
    styles() {
      let styles = ''
      if (this.bgColorHex) {
        styles += `background-color: ${this.bgColorHex};`
      }
      if (this.textColorHex) {
        styles += `color: ${this.textColorHex};`
      }
      return styles
    },
    classes() {
      if (this.customClasses) {
        return this.customClasses
      }

      return 'bg-light'
    },
  },
}
</script>

<style>

</style>